export const GET_CUSTOM_PAYROLL_SETTINGS = 'GET_CUSTOM_PAYROLL_SETTINGS';
export const UPDATE_CUSTOM_PAYROLL_SETTINGS = 'UPDATE_CUSTOM_PAYROLL_SETTINGS';
export const DELETE_FUTURE_CYCLE = 'DELETE_FUTURE_CYCLE';
